"use strict";

function accordionTitles() {
  let titleCount = 0;
  document.querySelectorAll('.accordions .accordion-title').forEach((acTitle) => {
    titleCount++;
    let id = 'accordion-' + titleCount;
    let expanded = false;

    let button = document.createElement('button');
    button.setAttribute('onclick', 'return false;');
    button.setAttribute('aria-controls', id);

    if (acTitle.classList.contains('open')) {
      button.setAttribute('aria-expanded', true);
      acTitle.classList.add('is-active');
      wrapInner(acTitle, button);
    } else {
      button.setAttribute('aria-expanded', false);
      wrapInner(acTitle, button);
    }
  });
}

function accordionContent() {
  let contentCount = 0;
  document.querySelectorAll('.accordions .accordion-content').forEach((acContent) => {
    contentCount++;
    let id = 'accordion-' + contentCount;

    if (acContent.previousElementSibling.classList.contains('is-active')) {
      acContent.setAttribute('id', id);
      acContent.setAttribute('aria-hidden', 'false');
    } else {
      acContent.setAttribute('id', id);
      acContent.setAttribute('aria-hidden', 'true');
    }
  });
  return 'success';
}

function accordionButtons() {
  document.querySelectorAll('.accordions .accordion-title button').forEach((acButton) => {
    acButton.on('click', function (e) {
      e.preventDefault();

      let id = acButton.getAttribute('aria-controls');
      let state = acButton.getAttribute('aria-expanded');
      let panel = document.querySelector('.accordion-content#' + id);

      if (acButton.parentElement.classList.contains('is-active')) {
        acButton.parentElement.classList.remove('is-active');
        acButton.parentElement.classList.add('is-inactive');
        acButton.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      } else {
        acButton.parentElement.classList.remove('is-inactive');
        acButton.parentElement.classList.add('is-active');
        acButton.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });
  return 'success';
}

document.addEventListener("DOMContentLoaded", () => {
  "use strict";
  //Document Ready

  document.querySelectorAll('.accordions').forEach((accordion) => {
    accordion.classList.add('active');
  });

  let promiseTitles = new Promise((resolve) => {
    accordionTitles();
    resolve('success');
  });

  promiseTitles.then((value) => {
    let promiseContent = new Promise((resolve) => {
      accordionContent();
      resolve('success');
    });

    promiseContent.then((value) => {
      accordionButtons();
    });
  });
});